export const state = {
  maitriseLangue: undefined,
  maitriseLangues: [],
  communes: [],
  sousMaitriseLangue: undefined,
  sousMaitriseLangues: []
}